import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { deleteRequest, fetchRequest } from "@actions/user-role";
import UserRolesTable from "@components/user-roles/Table";
import TableRenderer from "@hocs/TableRenderer";
import { UserRole } from "@models/user-role";
import { FormattedMessage } from "react-intl";
import { Button, Card } from "antd";
import { getUserRolesList } from "@reducers/user-roles";
import SearchUserRolesComponent from "@components/user-roles/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: UserRole[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class UsersRolesPage extends React.Component<AllProps> {
  deleteUserRole = (item: UserRole): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/users/roles/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.create_new_role"
                defaultMessage={`Create Role`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchUserRolesComponent search={search} />
          </Card>

          <UserRolesTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteUserRole}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ userRoles }: ApplicationState) => ({
  loading: userRoles.loading,
  errors: userRoles.errors,
  data: getUserRolesList(userRoles),
  count: userRoles.count
});

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(UsersRolesPage));
